import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import KolThumbnailGroup from '@/components/common/kol-thumbnail-group'
import { useIntl } from '@/i18n/hooks/use-intl'

export interface MentionKolListProps {
  kols: {
    uuid: string
    name: string
  }[]
  onClickMaximumMentionKol?: (data: MentionKolListProps['kols'][0]) => void
  isDemo?: boolean
}

const MentionKolList: FunctionComponent<MentionKolListProps> = ({
  kols,
  onClickMaximumMentionKol,
  isDemo,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Wrapper>
      <Text>{formatMessage({ id: 'kol:mentioned_brands' })}</Text>
      <KolThumbnailGroup
        data={kols.map((kol) => {
          return {
            ...kol,
            tooltipTitle: kol.name,
          }
        })}
        from='Competitor'
        isDemo={isDemo}
        onClickMaximumItem={onClickMaximumMentionKol}
      />
    </Wrapper>
  )
}

const Text = styled.div`
  color: ${({ theme }): string => theme.colors.text.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  ${Text} {
    margin: 0 4px 0 0;
  }
`

export default MentionKolList
